import { createAsyncThunk } from 'app/store/utils';
import {
  ApiErrorCodeTypes,
  AuthPersistence,
  SECURITY_ERROR,
} from 'types/enums';
import { apiErrorHandler } from 'app/utils/utils';
import { AxiosError } from 'axios';
import { DISABLED_COOKIES_MSG } from 'app/components/NoCookies/NoCookiesDialog/constants';
import { fetchApiKeyWebEffect, fetchBootstrapEffect } from './effects';

export const fetchAuthLinksEffect = createAsyncThunk(
  'authLinks/fetch',
  async (_, { dispatch, getState }) => {
    const state = getState();
    const { apiKeyWeb } = state.auth;
    const { services } = state.auth;

    try {
      if (!apiKeyWeb) {
        await dispatch(fetchApiKeyWebEffect());
      }
      if (!services) {
        await dispatch(fetchBootstrapEffect({}));
      }
    } catch (e: any) {
      if (e?.code === 'ECONNABORTED') {
        return;
      }
      throw e;
    }
  }
);

export const getAuthPersistenceType = ({
  isDevWithHttp,
  isWebClient,
  rememberMe,
}: {
  isDevWithHttp: boolean;
  isWebClient: boolean;
  rememberMe: boolean;
}) => {
  if (isDevWithHttp || !isWebClient) {
    return AuthPersistence.APP;
  }

  if (isWebClient && rememberMe) {
    return AuthPersistence.REMEMBER;
  }

  return AuthPersistence.NONE;
};

export const formErrorMessageSignIn = (e: AxiosError<any>) => {
  if (e?.name === SECURITY_ERROR) {
    return DISABLED_COOKIES_MSG;
  }

  const error = e?.response?.data?.error;
  if (
    error?.errorCode === ApiErrorCodeTypes.BAD_CREDENTIALS ||
    error?.statusReason === ApiErrorCodeTypes.BAD_REQUEST
  ) {
    return 'The email and password combination is incorrect';
  }
  return apiErrorHandler(e.response);
};
